export const strings = {
  title: 'إدارة الاختبارات',
  subtitle: 'اختبار لكل دورة، وقواعد اختيار أسئلته',
  create: 'اختبار جديد',
  close: 'إغلاق',
  save: 'حفظ',
  saved: 'تم الحفظ بنجاح',
  deleted: 'تم الحذف بنجاح',
  actionFailed: 'تعذر إتمام العملية',
  fail: {
    list: 'تعذر تحميل الاختبارات',
    load: 'تعذر تحميل بيانات هذا الاختبار',
    save: 'تعذر حفظ الاختبار',
    delete: 'تعذر حذف الاختبار',
  },
  deleteConfirm: 'هل أنت متأكد من حذف هذا الاختبار؟',
  allCoursesHaveExam: 'كل الدورات لديها اختبار بالفعل',

  columns: {
    index: 'م',
    course: 'الدورة',
    name: 'اسم الاختبار',
  },

  row: {
    edit: 'تعديل',
    delete: 'حذف',
  },

  form: {
    editTitle: 'تعديل الاختبار',
    createTitle: 'اختبار جديد',
    course: 'الدورة',
    nameAr: 'الاسم بالعربية',
    nameEn: 'الاسم بالإنجليزية',
    passLimit: 'درجة النجاح',
    tries: 'عدد المحاولات',
    forceWatch: 'إلزام بمشاهدة المحتوى',
    hideAnswers: 'إخفاء الإجابات',
    preventIfSucceeded: 'منع إعادة الاختبار بعد النجاح',
    rewatch: 'نسبة إعادة المشاهدة عند الرسوب',
    required: 'هذا الحقل مطلوب',
  },

  rules: {
    viewQuestions: 'عرض الأسئلة',
    hideQuestions: 'إخفاء الأسئلة',
    /* The count with the noun Arabic agreement needs. */
    questions: (count) =>
      count === 1 ? 'سؤال واحد' : count === 2 ? 'سؤالان' : count <= 10 ? `${count} أسئلة` : `${count} سؤالًا`,
    draws: (count, total) => `تختار كل محاولة ${count} من ${total}`,
    shortfall: (total, count) => `في البنك ${total} فقط بهذا المستوى، والقاعدة تطلب ${count}`,
    noQuestions: 'لا توجد أسئلة بهذا المستوى في بنك الموضوع',
    loadingQuestions: 'جار تحميل الأسئلة…',
    questionsFailed: 'تعذر تحميل الأسئلة. افتح بنك الأسئلة للمحاولة مجددا.',
    manageQuestions: 'إدارة بنك الأسئلة',
    title: 'قواعد اختيار الأسئلة',
    topic: 'الموضوع',
    level: 'مستوى الصعوبة',
    count: 'عدد الأسئلة',
    available: 'المتاح',
    total: 'أسئلة كل محاولة',
    add: 'إضافة قاعدة',
    remove: 'حذف',
    empty: 'لم تضف أي قاعدة بعد',
    tooMany: 'العدد المطلوب أكبر من عدد الأسئلة المتاحة',
  },
}
